export const sustainabilityTips = [
  {
    message: `You and your organisation can access our sustainability school resources for free`,
    link: "https://www.supplychainschool.co.uk/"
  }
];
